import { useAuthenticationContext } from '@festina-life/authentication'
import type { Optional } from '@festina-life/core'

import { useHook } from '../lenteHooks'
import { useAvailableComponents } from './useAvailableComponents'

export const useFetchPayableStopText = (id: Optional<string>) => {
  const { pseudonymization } = useAuthenticationContext()
  const { isUsingLegalEntity } = useAvailableComponents()
  const tenantId = useHook('routing.tenant.useTenantParam')()
  const shouldFetch =
    !!pseudonymization?.moneyOut?.payableStop && isUsingLegalEntity
  const { data: text } = useHook('fetchers.crm.useFetchPiiEntry')(
    {
      tenantId,
      id,
    },
    { enabled: shouldFetch },
  )

  return shouldFetch ? text : id
}
